import React, { FC } from 'react'
import { isEmpty, map } from 'lodash'
import { Trans } from '@lingui/macro'

import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import { ITag } from '../../types/IEventsPageTag'

import './TagList.less'

interface IProps {
  tags: ITag[]
}

const TagList: FC<IProps> = ({ tags }) => {
  if (isEmpty(tags)) return null

  return (
    <div className="TagList">
      <span className="TagList__label">
        <Trans>Tags</Trans>:
      </span>
      {map(tags, (tag) => (
        <a
          className="TagList__link"
          key={tag.id}
          onClick={() => navigateTo(linkBuilder.eventTag(tag.id))}
        >
          {tag.name}
        </a>
      ))}
    </div>
  )
}

export default TagList
